import common from './common'
import auth from './auth'
import user from './user'
import order from './order'
import dom from './dom'
import toast from './toast'
import store from './store'
import report from './report'
import outlet from './outlet'
import catalog from './catalog'
import currency from './currency'

export default {
  common,
  auth,
  user,
  order,
  dom,
  toast,
  store,
  report,
  outlet,
  catalog,
  currency
}
